import { render } from "./Info.vue?vue&type=template&id=580b197f"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=580b197f&lang=css"

import exportComponent from "/Users/peerasak/Work-tdd/krucare-lite-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__